import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { trackUiError } from '../lib/telemetry';

export default class PlatformErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('PlatformErrorBoundary caught error:', error);
    console.error('PlatformErrorBoundary stack:', error?.stack || '(no stack)');
    console.error(
      'PlatformErrorBoundary component stack:',
      errorInfo?.componentStack || '(no component stack)',
    );
    trackUiError(error, {
      componentStack: errorInfo?.componentStack || '',
      source: 'error_boundary',
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 3,
          }}
        >
          <Alert
            severity="error"
            sx={{ maxWidth: 560, width: '100%' }}
            action={
              <Button color="inherit" size="small" startIcon={<RefreshIcon />} onClick={this.handleReload}>
                Reload
              </Button>
            }
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              Something went wrong
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              The error was logged for the platform team. Try reloading the page.
            </Typography>
            {process.env.NODE_ENV !== 'production' && this.state.error?.message && (
              <Typography
                variant="caption"
                component="pre"
                sx={{ mt: 2, whiteSpace: 'pre-wrap', opacity: 0.85 }}
              >
                {this.state.error.message}
              </Typography>
            )}
          </Alert>
        </Box>
      );
    }

    return this.props.children;
  }
}

export { PlatformErrorBoundary };
